import React, { useState } from 'react'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Services } from '@/services/services'


export const Redirect = (params: { services: Services }) => {
  const [searchParams] = useSearchParams()
  const to = searchParams.get("to")
  const langCode = searchParams.get("lang")
  // the code is for demonstration on 
  const login = searchParams.get("login")
  const password = searchParams.get("password")
  const [message, setMessage] = useState('')
  const { services } = params

  useEffect(() => {
    new Promise(async (resolve, reject) => {
      if (langCode) {
        services.i18n.setDefaultLang(langCode)
        try {
          await services.session.initSession()
          services.session.setLang(langCode)
        } catch (e) { }
      }
      if (login) {
        await services.session.login({
          username: login,
          password: password || ''
        }).catch((error) => {
          setMessage('login error')
        })
      }
      resolve(null)
    }).then(() => {
      if (to) {
        window.location.href = to;
        // http://localhost:8080/redirect?lang=es&to=/
        // /redirect?lang=es&to=/communal/machine/4a10e1c0-b1c8-48fb-ac93-4539aaff6444/failures/add
        // https://lemarpol.evoltag.pl/communal/redirect?login=demo&password=demo&to=/communal/machine/cb11973a-d432-4483-ba9b-f025f5a1452b
      }
    })
  }, [to, langCode]);

  return <p>Redirecting... {message}</p>;
};
